import preQualImg from "../../../assets/img/Prequalify-200.png";
import projectImg from "../../../assets/img/projects-200.png";
import proposalImg from "../../../assets/img/Proposal-200.png";
// import calculatorImg from "../../../assets/img/calculator.jpg";
import calculatorImg from "../../../assets/img/calculator-200.png";
import prequelMasterKeyImg from "../../../assets/img/qualkey-200.png";
import ContactOutreachIcon from "../../../assets/img/contactoutreach-200.png";
import capabilitiesImg from "../../../assets/img/capabilitystatement-200.png";
import siteVisit from "../../../assets/img/site_visit-200.jpg";
import siteRoute from "../../../assets/img/site route  router-01.png"
import purpleCircle from "../../../assets/img/sidebar/color-symbol.png";
import dealsIcon from "../../../assets/img/sidebar/svg/deals.svg";
import crmIcon from "../../../assets/img/sidebar/crm_2.png";
import itbImportIcon from "../../../assets/img/sidebar/svg/itb-import.svg";

export const Pages = {
  "Project Research": {
    id: "projects_overview",
    imgSrc: projectImg,
    description: "Construction project data for prospecting, analyzing, researching.",
    linkTo: "/projects_overview",
    name: "Project Research"
  },
  "Project Board": {
    id: "projects_overview",
    imgSrc: projectImg,
    description:
      "Construction project data for prospecting, analyzing, researching.",
    linkTo: "/projects_overview",
    name: "Project Board"
  },
  "Cleanup Calculator": {
    id: "cleanup_calculator_overview",
    imgSrc: calculatorImg,
    description:
      "Calculates bid amount estimates and analyze potential cost and profits. Win more bids.",
    linkTo: "/cleanup_calculator_overview",
    name: "Cleaning Calculator"
  },
  "Cleanup Rates": {
    id: "cleanup_calculator_overview",
    imgSrc: calculatorImg,
    description:
      "Calculates bid amount estimates and analyze potential cost and profits. Win more bids.",
    linkTo: "/cleanup_calculator_overview",
    name: "Cleaning Rates"
  },
  "Proposal Generator": {
    id: "proposal",
    imgSrc: proposalImg,
    description:
      "Standardize proposal creation with templates. Satisfy customer needs with the correct scope of work.",
    linkTo: "/proposal",
    name: "Proposal"
  },
  "Paint Proposal": {
    id: "proposal",
    imgSrc: proposalImg,
    description:
      "Standardize proposal creation with templates. Satisfy customer needs with the correct scope of work.",
    linkTo: "/paint_proposal",
    name: "Proposal"
  },
  "Proposal Templates": {
    id: "proposal",
    imgSrc: proposalImg,
    description:
      "Standardize proposal creation with templates. Satisfy customer needs with the correct scope of work.",
    linkTo: "/proposal",
  },
  PlanRoom: {
    id: "planify",
    imgSrc: preQualImg,
    description:
      "Unleash the Power of Pre-Qualification and Dynamic Plan Rooms.",
    linkTo: "/planify",
    name: "PlanRoom"
  },
  PreQualify: {
    id: "planify",
    imgSrc: preQualImg,
    description:
      "Unleash the Power of Pre-Qualification and Dynamic Plan Rooms.",
    linkTo: "/planify",
    name: "PreQualify"
  },
  QualKey: {
    id: "qualkey",
    imgSrc: prequelMasterKeyImg,
    description:
      "Centralize company information to utilize in vendor application forms. Gather and answer up to 240 questions.",
    linkTo: "/qualkey",
    name:"QualKey"
  },
  "Capability Statement": {
    id: "capability_statement",
    imgSrc: capabilitiesImg,
    description:
      "A single-page summary highlighting your business operations and main contact point.",
    linkTo: "/capability_statement",
    name: "Capability Statement"
  },
  "Contact Outreach": {
    id: "contact_outreach",
    imgSrc: ContactOutreachIcon,
    description:
      "Tailored email marketing and contact management tool for North American construction industry professionals.",
    linkTo: "/contact_outreach",
    name: "Contact Outreach"
  },
  "Site Visit Sheet":  {
    id: "site_visit",
    description:
      "Facilitate and manage construction site visits, streamlining the process of recording observations",
    imgSrc: siteVisit,
    linkTo: "/site_visit",
    name: "Site Visit Sheet"
  },
  "Site Route Router": {
    id: "site_route_router",
    description: "Optimize job site visits, build personal connections, and uncover new business opportunities. With integrated route planning, it significantly enhances efficiency.",
    imgSrc: siteRoute,
    linkTo: "/site_router",
    name: "Site Route Router"
  },
  "Deal Marketplace": {
    id: "deal_marketplace",
    imgSrc: dealsIcon,
    linkTo: "/deal/marketplace",
    name: "Deal Marketplace"
  },
  "New Deal": {
    id: "create_deal",
    imgSrc: dealsIcon,
    linkTo: "/create_deal",
    name: "New Deal"
  },
  "Contact Management": {
    id: "crm",
    imgSrc: crmIcon,
    linkTo: "/crm",
    name: "Contact Management"
  },
  "Contact Enrichment": {
    id: "enrich",
    imgSrc: purpleCircle,
    linkTo: "/enrich",
    name: "Contact Enrichment"
  },
  "Pipeline": {
    id: "pipeline",
    imgSrc: dealsIcon,
    linkTo: "/myganarpro/favorites",
    name: "Pipeline"
  },
  "ITB Importer": {
    id: "itb_import",
    imgSrc: itbImportIcon,
    linkTo: "/itb-import",
    description: "Automatically import Invitation to Bid emails from your Gmail inbox and convert them to deals",
    name: "ITB Importer"
  }
  // You can add more items following the same pattern
};
